"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosLotteryBookUpdateInputSchema = exports.APosLotteryBookCreateInputSchema = exports.APosLotteryBookSchema = exports.APosLotteryBookStatusSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosLotteryBookStatusSchema = zod_1.z.enum([
    'received',
    'activated',
    'selling',
    'settled',
    'returned',
    'closed',
]);
exports.APosLotteryBookSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    bookId: id_schema_1.EntityIdSchema,
    gameId: id_schema_1.EntityIdSchema,
    bookNumber: zod_1.z.string().min(1).max(100),
    status: exports.APosLotteryBookStatusSchema,
    totalTickets: zod_1.z.number().int().min(1),
    ticketsSold: zod_1.z.number().int().min(0).default(0),
    ticketsRemaining: zod_1.z.number().int().min(0),
    grossSales: zod_1.z.number().int().min(0).default(0).describe('Gross sales in cents'),
    prizePaidOut: zod_1.z.number().int().min(0).default(0).describe('Prize paid out in cents'),
    locationId: id_schema_1.EntityIdSchema,
    activatedAt: zod_1.z.number().optional().describe('Unix timestamp in milliseconds'),
    activatedBy: zod_1.z.string().optional(),
    receivedAt: zod_1.z.number().optional().describe('Unix timestamp in milliseconds'),
    settledAt: zod_1.z.number().optional().describe('Unix timestamp in milliseconds'),
    settlementId: zod_1.z.string().optional(),
    binNumber: zod_1.z.number().int().optional(),
    autoSettleAt: zod_1.z.number().optional().describe('Unix timestamp in milliseconds'),
    lastTicketSold: zod_1.z.number().int().optional(),
    nextTicket: zod_1.z.number().int().optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosLotteryBookCreateInputSchema = zod_1.z.object({
    gameId: id_schema_1.EntityIdSchema,
    bookNumber: zod_1.z.string().min(1).max(100),
    status: exports.APosLotteryBookStatusSchema,
    totalTickets: zod_1.z.number().int().min(1),
    ticketsRemaining: zod_1.z.number().int().min(0),
    locationId: id_schema_1.EntityIdSchema,
    ticketsSold: zod_1.z.number().int().min(0).optional(),
    grossSales: zod_1.z.number().int().min(0).optional(),
    prizePaidOut: zod_1.z.number().int().min(0).optional(),
    activatedAt: zod_1.z.number().optional(),
    activatedBy: zod_1.z.string().optional(),
    receivedAt: zod_1.z.number().optional(),
    settledAt: zod_1.z.number().optional(),
    settlementId: zod_1.z.string().optional(),
    binNumber: zod_1.z.number().int().optional(),
    autoSettleAt: zod_1.z.number().optional(),
    lastTicketSold: zod_1.z.number().int().optional(),
    nextTicket: zod_1.z.number().int().optional(),
});
exports.APosLotteryBookUpdateInputSchema = exports.APosLotteryBookCreateInputSchema.partial();
//# sourceMappingURL=lottery-book.schema.js.map